var v1="<div class=\"perDiem\"> <div class=\"lbaContainer_nav\"> <ul class=\"nav nav-pills nav-stacked lbaSubNav\"> <li> <a href=\"\" class=\"ng-binding\" ng-click=\"vm.setActiveTab('data')\">Per Diem Data</a> </li> <li> <a href=\"#/per-diem/file-upload\" class=\"ng-binding\" ng-click=\"vm.setActiveTab('upload')\">File Upload</a> </li> </ul> </div> <div class=\"lbaContainer_fields\"> <div ng-if=\"vm.activeTab == 'data'\"> <lba-per-diem-grid></lba-per-diem-grid> </div> </div> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaPerDiem.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaPerdiem/lbaPerDiem.html
// module id = 378
// module chunks = 0